import {Box, useMediaQuery} from "@mui/material";
import {styled} from "@mui/material/styles";
import MobileFooter from "./MobileFooter";
import DesktopFooter from "./DesktopFooter";

const Container = styled(Box)(({theme}) => ({
  [theme.breakpoints.up('xxs')]: {
    padding: theme.spacing(3, 2),
  },
  [theme.breakpoints.up('md')]: {
    padding: '30px 24px',
  },
  [theme.breakpoints.up('xl')]: {
    padding: '50px 40px',
  },
}))

const Footer = () => {
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('xl'));

  return (
    <Container>
      {
        isDesktop ? <DesktopFooter /> : <MobileFooter />
      }
    </Container>
  )
}

export default Footer;
